import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="12" cy="12" r="12" fill="#E9ECF2"/> <path d="M12 17.465a1.802 1.802 0 1 0 0-3.604 1.802 1.802 0 0 0 0 3.604" fill="#193446"/> <path d="M12.563 10.71a.562.562 0 1 0-1.126 0v3.75a.562.562 0 1 0 1.126 0z" fill="#193446"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 5.692a1.26 1.26 0 0 0-1.258 1.357l.002.021v6.097l-.238.168a2.75 2.75 0 0 0-1.165 2.256v.01a2.66 2.66 0 1 0 5.318 0v-.01a2.75 2.75 0 0 0-1.165-2.256l-.238-.168V7.07l.002-.021A1.26 1.26 0 0 0 12 5.692m-.955-.926a2.386 2.386 0 0 1 3.336 2.346v5.486a3.87 3.87 0 0 1 1.403 2.992 3.785 3.785 0 1 1-7.568 0 3.87 3.87 0 0 1 1.403-2.992V7.112a2.39 2.39 0 0 1 1.426-2.346" fill="#193446"/>' }
  })
);